<div id="confirm-pend-reason-display" data-testid="confirm-pend-reason-display">
  <div *ngIf="useIcon === 'warning'" id="warning-icon" data-testid="warning-icon" class="warning-icon"></div>
  <div *ngIf="useIcon === 'success'" id="success-icon" data-testid="success-icon" class="success-icon"></div>
  <div class="pend-reason-text" id="pend-reason">{{pendReasonDescription}}</div>
</div>
<div *ngIf="(isCreateWireTemplate$ | async) && (createTemplateCallSuccess$ | async)" class="create-template-text" 
  id="create-template-text" data-testid="create-template-text">
  <div id="wire-success-icon" data-testid="wire-success-icon" class="success-icon"></div>
  {{wireTemplateCopy}}</div>